import React from 'react'
import styled from 'styled-components'
import { Box } from 'pcln-design-system'
import { ChatBotPopOver, StickyChatBotOpener } from '@pcln/uc-chat-bot'
import analytics from '@/shared-utils/analytics'
import useSeti from '@/hooks/useSeti'
import { type ChatBotPopOverVal } from './TravelChatBot'

const ChatNotificationWrapper = styled(Box)`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 7;
`

function ChatNotification({
  openChatBotPopOver,
  setOpenChatBotPopOver,
  setChatBotDialogOpeningState,
  isChatBotDialogOpened
}: {
  openChatBotPopOver: ChatBotPopOverVal
  isChatBotDialogOpened: boolean
  setChatBotDialogOpeningState: (value: React.SetStateAction<boolean>) => void
  setOpenChatBotPopOver: (
    value: React.SetStateAction<ChatBotPopOverVal>
  ) => void
}) {
  const fireGA3EventFAB = () => {
    analytics.fireEvent({
      action: 'penny_trigger',
      category: 'pcln_home',
      label: `fav`
    })
  }

  const isFrequentNotification =
    useSeti('CHATBOT_FREQUENT_NOTIFICATION', true) === 'VARIANT'

  return (
    <ChatNotificationWrapper>
      {openChatBotPopOver === 'OPEN' ? (
        <ChatBotPopOver
          onClose={() => setOpenChatBotPopOver('ALREADY_OPENED')}
          onOpen={() => {
            fireGA3EventFAB()
            setChatBotDialogOpeningState(true)
            setOpenChatBotPopOver('ALREADY_OPENED')
          }}
          animationType="BottomToTopLeft"
          source="homepage"
          isFrequentNotification={isFrequentNotification}
          animationProperties={{
            from: {
              x: '100px',
              y: '150px'
            },
            to: {
              x: '0',
              y: '0'
            },
            bottom: '0'
          }}
          text={`Hi, I'm Penny, your AI travel assistant! How can I help you today?`}
          positionProps={{
            bottom: '90px',
            zIndex: '7',
            right: '21px'
          }}
        />
      ) : null}
      <StickyChatBotOpener
        openerTooltipProps={{
          center: false,
          right: true
        }}
        openerPosition={{
          bottom: '20px',
          right: '10px',
          zIndex: '7'
        }}
        openerTooltipStyle={{
          right: '6px'
        }}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onComponentRendered={/* istanbul ignore next */ () => {}}
        isChatBoxOpened={isChatBotDialogOpened}
        onClickHandler={() => {
          fireGA3EventFAB()
          setChatBotDialogOpeningState(true)
          setOpenChatBotPopOver('ALREADY_OPENED')
        }}
      />
    </ChatNotificationWrapper>
  )
}

export default ChatNotification
